import mapboxgl from 'mapbox-gl'
import MapboxglSettings from "@/helpers/settings/mapboxgl";

const MapboxglHelper = {

    recreatesourceandlayer: function(sourceandlayers, map)
    {
      
        sourceandlayers.forEach(sourcelayer => {
          if(sourcelayer.type === 'symbol'){
            this.addSymbolSourceAndLayer(sourcelayer, map);
          }
          if(sourcelayer.type === 'customsymbol'){
            this.addCustomSymbolSourceAndLayer(sourcelayer, map);
          }
          else if(sourcelayer.type === 'circle'){
            this.addCircleValueSourceAndLayer(sourcelayer, map);
          } 
          else if(sourcelayer.type === 'coloredcircle'){
            this.addColoredCircleValueSourceAndLayer(sourcelayer, map);
          } 
          else if(sourcelayer.type === 'clustercircle'){
            this.addCircleClusterValueSourceAndLayer(sourcelayer, map);
          }
          else if(sourcelayer.type === 'clustercircle'){
            this.addCircleClusterValueSourceAndLayer(sourcelayer, map);
          }
        }
        );
    },

    addCustomSymbolSourceAndLayer: function (sourcelayer, map) 
    {
      this.safeRemoveSourceAndLayers(map, sourcelayer.sourcename, [`${sourcelayer.layername}_layer`]);
      map.addSource(sourcelayer.sourcename, MapboxglSettings.geojsonsource(sourcelayer.jsondata));
      map.addLayer(MapboxglSettings.symbollayercolor(sourcelayer.layername, sourcelayer.sourcename, sourcelayer.colorcodes, sourcelayer.icon ));
      map.on('mouseenter', `${sourcelayer.layername}_layer` , function(e) { MapboxglSettings.infopopup(e, map)});
      map.on('mouseleave', `${sourcelayer.layername}_layer`, function() {MapboxglSettings.infopopupclose(map)});
  
    },
    addColoredCircleValueSourceAndLayer: function (sourcelayer, map) 
    {
      this.safeRemoveSourceAndLayers(map, sourcelayer.sourcename, [`${sourcelayer.layername}_layer`]);
      map.addSource(sourcelayer.sourcename, MapboxglSettings.geojsonsource(sourcelayer.jsondata));
      map.addLayer(MapboxglSettings.circlelayercolor(sourcelayer.layername, sourcelayer.sourcename, sourcelayer.colorcodes));
      map.setLayoutProperty(`${sourcelayer.layername}_layer`, 'visibility', sourcelayer.visibility);
      map.on('mouseenter', `${sourcelayer.layername}_layer` , function(e) { MapboxglSettings.infotextpopup(e, map)});
      map.on('mouseleave', `${sourcelayer.layername}_layer`, function() {MapboxglSettings.infotextpopupclose(map)});
  
    },

    addSymbolSourceAndLayer: function (sourcelayer, map) 
    {
      this.safeRemoveSourceAndLayers(map, sourcelayer.sourcename, [`${sourcelayer.layername}_layer`]);
      map.addSource(sourcelayer.sourcename, MapboxglSettings.geojsonsource(sourcelayer.jsondata));
  
      map.addLayer(MapboxglSettings.symbollayer(sourcelayer.layername, sourcelayer.sourcename));

      map.setLayoutProperty(`${sourcelayer.layername}_layer`, 'visibility', sourcelayer.visibility);
  
      map.on('mouseenter', `${sourcelayer.layername}_layer` , function(e) { MapboxglSettings.infopopup(e, map)});
      map.on('mouseleave', `${sourcelayer.layername}_layer`, function() {MapboxglSettings.infopopupclose(map)});
  
    },
  
    addCircleValueSourceAndLayer: function (sourcelayer, map) 
    {
      this.safeRemoveSourceAndLayers(map, sourcelayer.sourcename, [`${sourcelayer.layername}_layer`, `${sourcelayer.layername}_valuelayer`]);
      map.addSource(sourcelayer.sourcename, MapboxglSettings.geojsonsource(sourcelayer.jsondata));
  
      map.addLayer(MapboxglSettings.simplecirclelayer(sourcelayer.layername, sourcelayer.sourcename, sourcelayer.colorcodes));
      map.addLayer(MapboxglSettings.simplecirclevaluelayer(sourcelayer.layername, sourcelayer.sourcename, sourcelayer.colorcodes));

      map.setLayoutProperty(`${sourcelayer.layername}_layer`, 'visibility', sourcelayer.visibility);
      map.setLayoutProperty(`${sourcelayer.layername}_valuelayer`, 'visibility', sourcelayer.visibility);
  
      map.on('mouseenter', `${sourcelayer.layername}_layer` , function(e) { MapboxglSettings.infopopupobs(e, map)});
      map.on('mouseleave', `${sourcelayer.layername}_layer`, function() {MapboxglSettings.infopopupobsclose(map)});
    },
  
    addCircleClusterValueSourceAndLayer: function (sourcelayer, map) 
    {
      this.safeRemoveSourceAndLayers(map, sourcelayer.sourcename, [`${sourcelayer.layername}_layer`, `${sourcelayer.layername}_valuelayer`, `${sourcelayer.layername}_clustercountlayer`]);
      map.addSource(sourcelayer.sourcename, MapboxglSettings.geojsonsourcecluster(sourcelayer.jsondata));
  
      map.addLayer(MapboxglSettings.simplecirclelayerNew(sourcelayer.layername, sourcelayer.sourcename, sourcelayer.colorcodes));
      map.addLayer(MapboxglSettings.simplecirclevaluelayer(sourcelayer.layername, sourcelayer.sourcename, sourcelayer.colorcodes));
      map.addLayer(MapboxglSettings.simplecirclelayeClusterCount(sourcelayer.layername, sourcelayer.sourcename));
  
      map.setLayoutProperty(`${sourcelayer.layername}_layer`, 'visibility', sourcelayer.visibility);
      map.setLayoutProperty(`${sourcelayer.layername}_valuelayer`, 'visibility', sourcelayer.visibility);
      map.setLayoutProperty(`${sourcelayer.layername}_clustercountlayer`, 'visibility', sourcelayer.visibility);
  
      map.on('mouseenter', `${sourcelayer.layername}_layer` , function(e) { MapboxglSettings.infopopupobs(e, map)});
      map.on('mouseleave', `${sourcelayer.layername}_layer`, function() {MapboxglSettings.infopopupobsclose(map)});
      map.on('click', `${sourcelayer.layername}_layer`,function(e) { MapboxglSettings.clusterExpansionZoom(e, map,`${sourcelayer.layername}_layer`,sourcelayer.sourcename)});
      map.on('mouseenter',`${sourcelayer.layername}_layer`, function (e) { MapboxglSettings.clusterLeaves(e, map,`${sourcelayer.layername}_layer`,sourcelayer.sourcename)});
      map.on('mouseleave', `${sourcelayer.layername}_layer`, function() {MapboxglSettings.clusterLeavesclose(map)});
    },

    addMapLayer: function (sourcelayer, map) 
    {
      this.safeRemoveSourceAndLayers(map, `${sourcelayer.sourcename}_source`, [`${sourcelayer.layername}_layer`]);
        map.addSource(`${sourcelayer.sourcename}_source` , MapboxglSettings.rastersource(sourcelayer.jsondata));
        map.addLayer(MapboxglSettings.rasterlayer(`${sourcelayer.layername}_layer`, `${sourcelayer.sourcename}_source`)); 
    },

    loadmissingimages: function(e, map)
    {
      const id = e.id; // id of the missing image
      map.loadImage(window.location.origin + '/' + e.id + '.png', function (error, res) {
        if (error) {
        }
        try{
          if(!map.hasImage(e.id))
            map.addImage(e.id, res,  { sdf: true });
        }
        catch(e){
        } 
      });
    },

    // helper to remove layers and source if already present
    safeRemoveSourceAndLayers: function(map, sourceName, layerNames) {
      try {
        if (!map) return;
        // remove layers first
        if (Array.isArray(layerNames)) {
          layerNames.forEach(ln => {
            if (map.getLayer(ln)) {
              try { map.removeLayer(ln); } catch(e) { /* ignore */ }
            }
          });
        }
        // then remove source
        if (map.getSource(sourceName)) {
          try { map.removeSource(sourceName); } catch(e) { /* ignore */ }
        }
      } catch(e) {
        // swallow any errors to avoid breaking map initialization
      }
    }
  }

  
  export default MapboxglHelper;